import React from 'react';
import { navigateTo } from '../utils/navigation';

// Pestañas de la sección Clientes. "Saldos a favor" vive adentro de Clientes y no como ítem
// propio del menú: es otra vista de los mismos clientes.
const TABS = [
    { path: '/users', label: 'Clientes' },
    { path: '/storeCredits', label: 'Saldos a favor' },
];

export default function ClientesTabs({ active }) {
    return (
        <ul className="nav nav-tabs mb-3">
            {TABS.map((t) => (
                <li className="nav-item" key={t.path}>
                    <button type="button"
                        className={`nav-link ${active === t.path ? 'active' : ''}`}
                        style={{ background: 'none', border: 0, borderBottom: active === t.path ? '2px solid #007bff' : '2px solid transparent' }}
                        onClick={() => { if (active !== t.path) navigateTo(t.path); }}>
                        {t.label}
                    </button>
                </li>
            ))}
        </ul>
    );
}
